import React, { useState } from "react";
import { useForm } from "react-hook-form";
import axios from "axios";

import { request } from "../../../api";
import cancelPieceForm from "../cancel_piece_form";
import ImagePreview from "../../components/edit/ImagePreview";
import ImageDropzone from "../../components/edit/ImageDropzone";

const VtrgCenteredImageForm = ({
  data,
  instanceType,
  instanceId,
  pieceType,
  slot,
  updatePiece,
  setActionLoading,
  ordn,
  afterUpdateVtrgPiece,
  getPieceForm,
  blockType,
}) => {
  const [successMsg, setSuccessMsg] = useState(null);
  const [errorMsg, setErrorMsg] = useState(null);
  const [disableBtns, setDisableBtns] = useState(false);

  const [values, setValues] = useState({
    // id: data && data.id ? data.id : '',
    image: data && data.image ? data.image : "",
    back_color: data && data.back_color ? data.back_color : "",
    backmage: data && data.backmage ? data.backmage : "",
    remove_backmage: data && data.remove_backmage ? true : false,
    back_repeat: data && data.back_repeat ? true : false,
    pad_top: data && data.pad_top ? data.pad_top : "",
    pad_rgh: data && data.pad_rgh ? data.pad_rgh : "",
    pad_bot: data && data.pad_bot ? data.pad_bot : "",
    pad_lft: data && data.pad_lft ? data.pad_lft : "",
    max_width: data && data.max_width ? data.max_width : "",
    block_type: blockType && blockType,
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  // Изображения для нового блока: можно выбрать несколько, на каждое создаётся свой блок.
  // При редактировании используется только values.image (одно изображение)
  const [newImages, setNewImages] = useState([]);

  const updatedTime =
    data && data.updated_at ? new Date(data.updated_at).getTime() : 0;

  // image — изображение для нового блока; при редактировании не передаётся
  const buildFormData = (image) => {
    const dataForm = new FormData();

    Object.entries(values).forEach(([key, value]) => {
      // Файлы отправляем только если выбран новый, иначе на сервере остаётся текущий
      if (!["image", "backmage"].includes(key) || value instanceof File) {
        dataForm.set(key, value);
      }
    });

    if (image) {
      dataForm.set("image", image);
    }

    dataForm.append("kind", pieceType);
    dataForm.append("owner_type", instanceType);
    dataForm.append("owner_id", instanceId);
    dataForm.append("id", data && data.id);

    return dataForm;
  };

  const sendPiece = (dataForm) =>
    axios.post(`${request}/vitrage/pieces/${slot ? slot : "new"}`, dataForm, {
      headers: {
        "Content-Type": "multipart/form-data",
        "Access-Control-Allow-Origin": "*",
      },
    });

  // Создаём блоки по одному и по очереди, чтобы они встали в порядке выбора файлов.
  // Возвращает изображения, для которых блок создать не удалось
  const createPieces = async () => {
    const images = newImages;
    const failed = [];

    for (const [index, image] of images.entries()) {
      try {
        const response = await sendPiece(buildFormData(image));
        if (response.statusText === "OK" && response.data.content) {
          // final — последний блок пачки и все создались: можно закрывать панель добавления.
          // Ждём, пока блок встанет на своё место, иначе перестановки следующих блоков перемешаются
          await afterUpdateVtrgPiece(response.data.content, {
            final: index === images.length - 1 && !failed.length,
          });
        } else {
          failed.push(image);
        }
      } catch (error) {
        console.log(error);
        failed.push(image);
      }
    }

    return { total: images.length, failed };
  };

  const onSubmit = (localData, e) => {
    setDisableBtns(true);
    setErrorMsg(null);

    if (!slot) {
      if (!newImages.length) {
        setDisableBtns(false);
        setErrorMsg("Выберите хотя бы одно изображение");
        return;
      }

      createPieces().then(({ total, failed }) => {
        setActionLoading(null);

        if (!failed.length) {
          // Форма закрывается — свой стейт уже не трогаем
          getPieceForm(null);
          return;
        }

        setDisableBtns(false);
        // Созданные блоки уже на странице — в форме оставляем только неудавшиеся,
        // чтобы повторная отправка не создала дубли
        setNewImages(failed);
        setErrorMsg(
          failed.length === total
            ? "Произошли ошибки, пожалуйста попробуйте позже."
            : `Не удалось создать блоков: ${failed.length} из ${total}. Попробуйте отправить оставшиеся изображения ещё раз.`,
        );
      });
      return;
    }

    if (ordn) {
      setActionLoading(ordn);
    }

    Object.keys(localData)
      .filter((key) => key in values)
      .forEach((key) => (localData[key] = values[key]));

    sendPiece(buildFormData())
      .then((response) => {
        if (response.statusText === "OK") {
          setSuccessMsg("Изменения успешно внесены");
          afterUpdateVtrgPiece(
            response?.data?.data?.content
              ? response.data.data.content
              : localData,
          );
        } else {
          setErrorMsg("Произошли ошибки, пожалуйста попробуйте позже.");
        }
      })
      .catch((error) => {
        console.log(error);
        setErrorMsg("Произошли ошибки, пожалуйста попробуйте позже.");
      })
      .finally(() => {
        setDisableBtns(false);
        setTimeout(() => {
          setSuccessMsg(null);
          setErrorMsg(null);
          updatePiece(null);
          setActionLoading(null);
        }, 500);
      });
  };

  const onError = (errors, e) => {
    console.log(errors);
    setErrorMsg("Произошла ошибка");
  };

  return (
    <div className="vtrg-edit-body">
      <h3>Блок изображения:</h3>

      <form
        onSubmit={handleSubmit(onSubmit, onError)}
        noValidate="novalidate"
        className="vitrage_pieces_vtrg_centered_image"
        encType="multipart/form-data"
        action={`${request}/vitrage/pieces/${slot ? slot : "new"}}`}
        acceptCharset="UTF-8"
        dataremote="true"
        method="post"
      >
        <fieldset className="inputs">
          <label>{slot ? "Изображение" : "Изображения"}</label>

          <ImageDropzone
            name="image"
            multiple={!slot}
            onChange={(files) => {
              if (slot) {
                setValues((prev) => ({ ...prev, image: files[0] }));
              } else {
                setNewImages(files);
              }
            }}
          />
          {slot ? (
            <ImagePreview image={values.image} version={updatedTime} />
          ) : (
            newImages.length > 0 && (
              <div className="inline-hints">
                Выбрано изображений: {newImages.length}
                {newImages.length > 1 &&
                  " (для каждого будет создан отдельный блок)"}
                {newImages.map((file, index) => (
                  <ImagePreview
                    key={`${file.name}-${file.lastModified}-${index}`}
                    image={file}
                    label={null}
                  />
                ))}
              </div>
            )
          )}
        </fieldset>
        <fieldset className="inputs">
          <label>Цвет фона</label>
          <input
            type="color"
            name="back_color"
            defaultValue={values && values.back_color ? values.back_color : ""}
            placeholder="например: #FFF"
            {...register("back_color", { value: values.back_color })}
            onChange={(e) => {
              setValues((values) => {
                values.back_color = e.target.value;
                return values;
              });
            }}
          />
        </fieldset>

        <fieldset className="inputs">
          <label>Фоновое изображение</label>
          <input
            type="file"
            name="backmage"
            placeholder="Файл"
            {...register("backmage", { value: values.backmage })}
            onChange={(e) => {
              const file = e.target.files[0];
              setValues((prev) => ({ ...prev, backmage: file }));
            }}
          />
          <ImagePreview
            image={values.backmage}
            version={updatedTime}
            alt="Фоновое изображение"
          />
        </fieldset>
        <fieldset className="inputs">
          <label> Удалить фоновое изображение?</label>
          <input
            type="checkbox"
            name="remove_backmage"
            defaultChecked={values && values.remove_backmage ? true : false}
            {...register("remove_backmage", { value: values.remove_backmage })}
            onChange={(e) => {
              setValues((values) => {
                values.remove_backmage = e.target.checked;
                return values;
              });
            }}
          />
        </fieldset>
        <fieldset className="inputs">
          <label> Замостить фоновое изображение? </label>
          <input
            type="checkbox"
            name="back_repeat"
            defaultChecked={values && values.back_repeat ? true : false}
            {...register("back_repeat", { value: values.back_repeat })}
            onChange={(e) => {
              setValues((values) => {
                values.back_repeat = e.target.checked;
                return values;
              });
            }}
          />
        </fieldset>

        <fieldset className="inputs">
          <label>Отступ сверху, px</label>
          <input
            type="text"
            name="pad_top"
            defaultValue={values && values.pad_top ? values.pad_top : ""}
            placeholder="0"
            {...register("pad_top", { value: values.pad_top })}
            onChange={(e) => {
              setValues((values) => {
                values.pad_top = e.target.value;
                return values;
              });
            }}
          />
        </fieldset>

        <fieldset className="inputs">
          <label>Отступ справа, px</label>
          <input
            type="text"
            name="pad_rgh"
            defaultValue={values && values.pad_rgh ? values.pad_rgh : ""}
            placeholder="0"
            {...register("pad_rgh", { value: values.pad_rgh })}
            onChange={(e) => {
              setValues((values) => {
                values.pad_rgh = e.target.value;
                return values;
              });
            }}
          />
        </fieldset>

        <fieldset className="inputs">
          <label>Отступ снизу, px</label>
          <input
            type="text"
            name="pad_bot"
            defaultValue={values && values.pad_bot ? values.pad_bot : ""}
            placeholder="0"
            {...register("pad_bot", { value: values.pad_bot })}
            onChange={(e) => {
              setValues((values) => {
                values.pad_bot = e.target.value;
                return values;
              });
            }}
          />
        </fieldset>

        <fieldset className="inputs">
          <label>Отступ слева, px</label>
          <input
            type="text"
            name="pad_lft"
            defaultValue={values && values.pad_lft ? values.pad_lft : ""}
            placeholder="0"
            {...register("pad_lft", { value: values.pad_lft })}
            onChange={(e) => {
              setValues((values) => {
                values.pad_lft = e.target.value;
                return values;
              });
            }}
          />
        </fieldset>

        <fieldset className="inputs">
          <label>Макс. ширина, %</label>
          <input
            type="text"
            name="max_width"
            defaultValue={values && values.max_width ? values.max_width : ""}
            placeholder="100"
            {...register("max_width", { value: values.max_width })}
            onChange={(e) => {
              setValues((values) => {
                values.max_width = e.target.value;
                return values;
              });
            }}
          />
        </fieldset>
        <input
          type="hidden"
          name="kind"
          value={pieceType}
          {...register("kind", { value: pieceType })}
        />
        <input
          type="hidden"
          name="kind"
          value={pieceType}
          {...register("kind", { value: pieceType })}
        />
        <input
          type="hidden"
          name="owner_type"
          value={instanceType}
          {...register("owner_type", { value: instanceType })}
        />
        <input
          type="hidden"
          name="owner_id"
          value={instanceId}
          {...register("owner_id", { value: instanceId })}
        />

        {successMsg && <p className="success-hint">{successMsg}</p>}
        {errorMsg && <p className="error-hint">{errorMsg}</p>}
        {disableBtns && <span className="loading-hint"> Подождите ... </span>}

        <fieldset className={disableBtns ? "actions_disable" : "actions"}>
          <input type="submit" />
          <input
            type="reset"
            value="Отмена"
            onClick={() =>
              cancelPieceForm({ slot, updatePiece, afterUpdateVtrgPiece, getPieceForm })
            }
          />
        </fieldset>
      </form>
    </div>
  );
};

export default VtrgCenteredImageForm;
